import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import SelectDropdown from "../../../../../../Supporting files/SelectDropdown/SelectDropdown";
import "./../../BulkUpload.scss";

function ContactMapFields() {
  const [selectCols, setSelectCols] = React.useState("Select");
  const [firstNameCols, setFirstNameCols] = React.useState("Select");
  const [lastNameCols, setLastNameCols] = React.useState("Select");
  const [genderCols, setGenderCols] = React.useState("Select");
  const [emailCols, setEmailCols] = React.useState("Select");
  const [dobCols, setDOBCols] = React.useState("Select");
  const [mobileCols, setMobileCols] = React.useState("Select");

  const selectCols_data = [
    { key: "Select", value: "Select" },
    { key: "column:1", value: "Column:1" },
    { key: "column:2", value: "Column:2" },
    { key: "column:3", value: "Column:3" },
    { key: "column:4", value: "Column:4" },
    { key: "column:5", value: "Column:5" },
    { key: "column:6", value: "Column:6" },
    { key: "column:7", value: "Column:7" },
    { key: "column:8", value: "Column:8" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid xs={12} className="innerSection pl-10 pr-10 pb-13">
          <Grid container spacing={3}>
            <Grid xs={12} padding="0" className="mb-4">
              <Box className="detailSection">
                <div>
                  <div className="sectionTitle">
                    <h4>Personal Details</h4>
                  </div>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <Grid container>
                        <Grid xs={12} padding="0">
                          <h5 className="subHeading">Basic Info</h5>
                        </Grid>
                        <Grid xs={2}>
                          <p className="form_p text-right">EB Field :</p>
                        </Grid>
                        <Grid xs={4}>
                          <p className="form_p ">Import Field</p>
                        </Grid>
                        <Grid xs={2}>
                          <p className="form_p text-right">EB Field :</p>
                        </Grid>
                        <Grid xs={4}>
                          <p className="form_p ">Import Field</p>
                        </Grid>
                      </Grid>
                      <Grid xs={12} padding="0" paddingTop="12px">
                        <hr />
                      </Grid>
                    </Grid>

                    <Grid xs={12}>
                      <Grid container>
                        <Grid xs={6} padding="0">
                          <Grid container sx={{ alignItems: "center" }}>
                            <Grid xs={4} className="text-right">
                              <h5 className="fieldTitle">Title :</h5>
                            </Grid>
                            <Grid xs={8}>
                              <SelectDropdown
                                class_name="inputField"
                                title=""
                                value={selectCols}
                                attrName={setSelectCols}
                                value_update={updateMasterState}
                                dropdown_data={selectCols_data}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid xs={6} padding="0">
                          <Grid container sx={{ alignItems: "center" }}>
                            <Grid xs={4} className="text-right">
                              <h5 className="fieldTitle">First Name :</h5>
                            </Grid>
                            <Grid xs={8}>
                              <SelectDropdown
                                class_name="inputField"
                                title=""
                                value={firstNameCols}
                                attrName={setFirstNameCols}
                                value_update={updateMasterState}
                                dropdown_data={selectCols_data}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid xs={6} padding="0">
                          <Grid container sx={{ alignItems: "center" }}>
                            <Grid xs={4} className="text-right">
                              <h5 className="fieldTitle">Last Name :</h5>
                            </Grid>
                            <Grid xs={8}>
                              <SelectDropdown
                                class_name="inputField"
                                title=""
                                value={lastNameCols}
                                attrName={setLastNameCols}
                                value_update={updateMasterState}
                                dropdown_data={selectCols_data}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid xs={6} padding="0">
                          <Grid container sx={{ alignItems: "center" }}>
                            <Grid xs={4} className="text-right">
                              <h5 className="fieldTitle">Gender :</h5>
                            </Grid>
                            <Grid xs={8}>
                              <SelectDropdown
                                class_name="inputField"
                                title=""
                                value={genderCols}
                                attrName={setGenderCols}
                                value_update={updateMasterState}
                                dropdown_data={selectCols_data}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid xs={6} padding="0">
                          <Grid container sx={{ alignItems: "center" }}>
                            <Grid xs={4} className="text-right">
                              <h5 className="fieldTitle">Date of Birth :</h5>
                            </Grid>
                            <Grid xs={8}>
                              <SelectDropdown
                                class_name="inputField"
                                title=""
                                value={dobCols}
                                attrName={setDOBCols}
                                value_update={updateMasterState}
                                dropdown_data={selectCols_data}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid xs={6} padding="0">
                          <Grid container sx={{ alignItems: "center" }}>
                            <Grid xs={4} className="text-right">
                              <h5 className="fieldTitle">Email :</h5>
                            </Grid>
                            <Grid xs={8}>
                              <SelectDropdown
                                class_name="inputField"
                                title=""
                                value={emailCols}
                                attrName={setEmailCols}
                                value_update={updateMasterState}
                                dropdown_data={selectCols_data}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid xs={6} padding="0">
                          <Grid container sx={{ alignItems: "center" }}>
                            <Grid xs={4} className="text-right">
                              <h5 className="fieldTitle">Mobile :</h5>
                            </Grid>
                            <Grid xs={8}>
                              <SelectDropdown
                                class_name="inputField"
                                title=""
                                value={mobileCols}
                                attrName={setMobileCols}
                                value_update={updateMasterState}
                                dropdown_data={selectCols_data}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ContactMapFields;
